import React from 'react';
import {connect} from 'react-redux';
import { Link } from 'react-router-dom';
import {history} from '../routers/AppRouter';
import FlipMove from 'react-flip-move';
import API from './api';
import WorkListItem from './WorkListItem';
import selectWorks from '../selectors/works'
import {setFieldFilter} from '../actions/filters'
import Equalizer from 'react-equalizer'
import ScrollArea from 'react-scrollbar';
import PageAnimation from '../components/PageTransitions';


class WorkPage extends React.Component{
  state = {
    active:[{
      all:"active",
      web:"",
      design:"",
      mob:"",
      identity:"",
    }],
    work_page_title:'',
    work_page_subtitle:'',
  }

  componentWillMount = () =>{

    if (this.props.settingsData.dataIn){
      // if data stored on Redux
      console.log("data stored in redux work");
      this.setState({
        work_page_title:this.props.settingsData.work_page_title,
        work_page_subtitle:this.props.settingsData.work_page_subtitle,
      });
    } else{
      // if data not stored on Redux try to fetch again
      console.log("data NOT stored in redux work!!!!!!!!");
      API.get(`settings`)
      .then(res => {
        const settings = res.data;
        this.setState({
          work_page_title:settings.work_page_title,
          work_page_subtitle:settings.work_page_subtitle,
        });
      });
    }

    const filds =this.props.filters.fields;
    console.log(filds)
    if(filds[0]){
      this.setState({active:[{all:"",web:"active",design:"",mob:"",identity:"",}]});
    }
    if(filds[1]){
      this.setState({active:[{all:"",web:"",design:"active",mob:"",identity:"",}]});
    }
    if(filds[2]){
      this.setState({active:[{all:"",web:"",design:"",mob:"active",identity:"",}]});
    }
    if(filds[3]){
      this.setState({active:[{all:"",web:"",design:"",mob:"",identity:"active",}]});
    }
    if(filds[0] && filds[1] && filds[2] && filds[3]){
      this.setState({active:[{all:"active",web:"",design:"",mob:"",identity:"",}]});
    }
  }
  handelallFilter = () =>{
    this.setState({active:[{all:"active",web:"",design:"",mob:"",identity:"",}]});
    this.props.setFieldFilter([true,true,true,true]);
  }
  handelWebFilter = () =>{
    this.setState({active:[{all:"",web:"active",design:"",mob:"",identity:"",}]});
    this.props.setFieldFilter([true,false,false,false]);
  }
  handeldesignFilter = () =>{
    this.setState({active:[{all:"",web:"",design:"active",mob:"",identity:"",}]});
    this.props.setFieldFilter([false,true,false,false]);
  }
  handelmobFilter = () =>{
    this.setState({active:[{all:"",web:"",design:"",mob:"active",identity:"",}]});
    this.props.setFieldFilter([false,false,true,false]);
  }
  handelIdentityFilter = () =>{
    this.setState({active:[{all:"",web:"",design:"",mob:"",identity:"active",}]});
    this.props.setFieldFilter([false,false,false,true]);
  }
  renderWorks(){
    if (this.props.works.length === 0){
        return (
            <div className="works--message">
                <span>No works.</span>
            </div>
        );
    } else {
        return this.props.works.map((works) => {
          return <WorkListItem frompage="/work" topage={history.location.pathname} key={works.id} {...works} />;
        });
    }
  }

  componentDidMount = ()=>{
    console.log(this.state.active)
  }

  render(){
      return(
        <PageAnimation frompage={history.location.state.prevPath} topage={history.location.pathname} animP="/work">
        <ScrollArea
            smoothScrolling={true}
            onScroll={() => {
              document.querySelector(".logo").classList.remove("home");
            }}
            className="workPage"
            verticalContainerStyle={{background:"#b22c59"}}
            verticalScrollbarStyle={{background:"#e52f6c"}}
            horizontal={false}
            >
          
          <div className="fixedNav">
            <Link className="back" to={{pathname: 'about', state: { prevPath: location.pathname }}}><span className="icon-back-left"></span> About</Link>
            <p className="current">Work <span className="icon-arrow-right"></span></p>
          </div>
          <div className="topShadow"></div>
          <div className="bContainer">
            <div className="title">
              <div className="row">
                <div className="col-sm-8">
                
                  <p>{this.state.work_page_subtitle}</p>
                  <span dangerouslySetInnerHTML={{__html: this.state.work_page_title}} />
                  
                </div>
                <div className="col-sm-4">
                  <div className="filtersBox">
                    <div className="head"></div>
                    <div className="filtersBody">
                      <p className={this.state.active[0].all}><span onClick={this.handelallFilter}>All services</span></p>
                      <p className={this.state.active[0].design}><span onClick={this.handeldesignFilter}>Design</span></p>
                      <p className={this.state.active[0].web}><span onClick={this.handelWebFilter}>Development</span></p>
                      {/*<p className={this.state.active[0].identity}><span onClick={this.handelIdentityFilter}>Corporate identity</span></p>*/}
                      {/*<p className={this.state.active[0].mob}><span onClick={this.handelmobFilter}>Mobile application</span></p>*/}
                    </div>
                  </div>
                </div>
              </div>
              
            </div>
            <div className="content">
                <FlipMove maintainContainerHeight={true} staggerDelayBy={20}>
                  {this.renderWorks()}
                  <div className="clearfix"></div>
                </FlipMove>
                
                {/*<div className="sortlist">
                  <a href="https://www.sortlist.com/agency/bni-bright-new-ideas?ref=review-widget-1" target="_blank"> <img  alt="Click here to view the agency's profile on Sortlist" src="https://www.sortlist.com/widget/bni-bright-new-ideas/review?ref=review-widget-1"/> </a>
                </div>*/}
            </div>
            <div className="clearfix"></div>
          </div>
        </ScrollArea>
        </PageAnimation>
    );
  }
}

const mapStateToProps = (state) =>{
  return{
      works: selectWorks(state.works, state.filters),
      filters: state.filters,
      settingsData: state.settings
  };
};

const mapDispatchToProps = (dispatch) => ({
  setFieldFilter: (filds) => dispatch(setFieldFilter(filds))
});

export default connect(mapStateToProps,mapDispatchToProps)(WorkPage);



// WEBPACK FOOTER //
// ./src/components/WorkPage.js